import type { SubscriptionStatus } from "api";
import cn from "classnames";

const LABELS: Record<SubscriptionStatus, string> = {
  active: "Active",
  limit_reached: "Limit Reached",
  expired: "Expired",
};

const MODIFIERS: Record<SubscriptionStatus, string> = {
  active: "pc-tag--ok",
  limit_reached: "pc-tag--bad",
  expired: "pc-tag--warn",
};

export const StatusTag = ({ status }: { status: SubscriptionStatus }) => (
  <span className={cn("pc-tag", MODIFIERS[status])}>{LABELS[status]}</span>
);
